import { subform } from '@/react/view-models/Form/subform';
import { OrderDigitalShippingInfoModel } from '@/services/models/Order';
import { DTO } from '@/type-utils';
import { makeObservable } from 'mobx';
import { FormModel } from '../../../Form';
import { ContactInfoFormModel } from './ContactInfoFormModel';
import type { IGiftCardShippingForm } from './IGiftCardShippingForm';

/** @inheritdoc */
export class GiftCardShippingFormModel
  extends FormModel<IGiftCardShippingForm>
  implements IGiftCardShippingForm
{
  /** @inheritdoc */
  @subform()
  public contactInfo: ContactInfoFormModel;

  /** @inheritdoc */
  public constructor(dto: DTO<IGiftCardShippingForm>) {
    super(dto);

    this.contactInfo = ContactInfoFormModel.from(dto.contactInfo);

    makeObservable(this);
  }

  /**
   * Creates an {@link OrderDigitalShippingInfoModel} object from this form. This object can then
   * be consumed by the order placement methods.
   *
   * @returns An {@link OrderDigitalShippingInfoModel} object with the relevant data this form
   * contains.
   */
  public toOrderShippingInfo(): OrderDigitalShippingInfoModel {
    const { email, phoneNumber } = this.contactInfo;

    return new OrderDigitalShippingInfoModel({ email, phoneNumber });
  }

  /** @inheritdoc */
  public toDTO(): DTO<IGiftCardShippingForm> {
    return { contactInfo: this.contactInfo.toDTO() };
  }
}
